<template>
    <div
            class="">
        <h4 class="text-center">Settings</h4>

        <!-- Automatic Sending Interval -->
        <div v-if="isSavable"
             class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Automatic Sending Interval</span>
            <select2 :options="intervals"
                     v-model:value="$data._interval"
                     :close-on-select="true"
            ></select2>
        </div>

        <!-- Day of week to send -->
        <div    v-if="permissions.can('manage_system_health_report')
                              && interval === 'weekly'
                              && isSavable"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Day of Week to Send Report</span>
            <select2 :options="weekdayOptions"
                     v-model:value="$data._receiveWeekday"
                     :close-on-select="true"
            ></select2>
        </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
        <label for="showHealthChecks">Show Health Checks in Report</label>
        <toggle
          id="showHealthChecks"
          name="showHealthChecks"
          v-model:value="$data._settings['show_health_checks']"
          @toggle="updateSettings($event, 'show_health_checks')">
        </toggle>
      </div>

<!--      Battery Checks -->
      <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
        <label for="showBatteryChecks">Show Battery Checks in Report</label>
        <toggle
          id="showBatteryChecks"
          name="showBatteryChecks"
          v-model:value="$data._settings['show_battery_checks']"
          @toggle="updateSettings($event, 'show_battery_checks')">
        </toggle>
      </div>

<!--      Calibration Checks -->
      <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
        <label for="showCalibrationChecks">Show Calibration Checks in Report</label>
        <toggle
          id="showCalibrationChecks"
          name="showCalibrationChecks"
          v-model:value="$data._settings['show_calibration_checks']"
          @toggle="updateSettings($event, 'show_calibration_checks')">
        </toggle>
      </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

import Select2 from "@/components/elements/select2";
import Toggle from "@/components/elements/toggle.vue";

const INTERVALS = {
    daily: 'Daily',
    weekly: 'Weekly',
    'semi-monthly': 'Semi-Monthly',
    monthly: 'Monthly',
}

const WEEKDAY_OPTIONS = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
}

export default {
    name: "SystemHealthReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Toggle, Select2},
    props: {
      settings: Object,
        receiveWeekday: {
            type: [Number, String],
            default: 1,
        },
        semiMonthHalf: {
            type: String,
            default: 'first',
        },
        // TODO. include this in JS instead
        weekdayOptions: {
            type: Object,
            default: WEEKDAY_OPTIONS,
        },
        intervals: {
            type: Object,
            default: INTERVALS,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        isSavable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            _receiveWeekday: this.receiveWeekday,
            _interval: this.interval,
            isSaving: false,
            _settings: this.settings,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      updateSettings(event, triggeringComponent = 'Unknown') {
        // Update the settings values based on the new local
        this.$emit('update:settings', this.$data._settings)
        this.$forceUpdate()
      },
      saveSettings() {
        this.$emit(`saveSettings`)
      },
    },
    computed: {},
    watch: {
        _interval(val, old) {
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        _receiveWeekday (val, old) {
            if (val !== old) {
                this.$emit('update:receiveWeekday', this.$data._receiveWeekday)
            }
        }
    },
}
</script>

<style scoped>

</style>